'use client';

import styles from '../../page.module.scss';
import bgShapeFooter from '../../assets/decos/bg-shape-green.svg';
import Link from 'next/link';
import SocialIcons from './SocialIcons';

export default function Footer() {
  return (
    <footer id="contacto" className={styles.containerFooter}>
      <img src={bgShapeFooter.src} alt="imagen decorativa de fondo" />
      <section className={styles.containerFooterContent}>
        <div className={styles.footerText1}>
          <p>
            La Libre Editora - Chacabuco 917 <br /> Ciudad de Buenos Aires
          </p>
          <Link className={styles.textLink} href={'/'}>
            Ir a inicio
          </Link>
        </div>
        <div className={styles.footerText2}>
          <p>Horarios de atención: Lunes a viernes 12 a 19 hs. </p>
          <p> Fines de semana y feriados 14 a 20 hs.</p>
          <p> Tel.: +54 9 11 6064 6581</p>
          <Link href={''}>lalibrearteylibros@gmail.com </Link>
        </div>
        <div className={styles.footerIconsContainer}>
          <SocialIcons className={styles.footerIcon} />
        </div>
      </section>
    </footer>
  );
}
